import { useCallback, useState } from "react";
import { AppUnderlinedTitle } from "../../../../shared/components/AppUnderlinedTitle";
import { useTranslation } from "react-i18next";
import {
  BotObject,
  ChatObject,
} from "../../../../services/api/instances/botApi/types";
import { useAppDispatch } from "../../../../services/redux/hooks/use-dispatch";
import { getBotMessagesAction } from "../../redux/actions";
import { useStorageSelectors } from "../../../../app/state/storageObjectSlice/hook/use-storage-selectors";
import { useChatsByRef } from "../../hook/use-chat-by-ref";
import { DialogChatsSelection } from "./Components/DialogChatsSelection";
import { ChatDatePicker } from "./Components/ChatDatePicker";
import { ChatbotMessagesLayout } from "./Components/ChatbotMessagesLayout";
import styles from "./styles.module.css";
import { useAppSelector } from "../../../../services/redux/hooks/use-selector";
import {
  selectChatMessages,
  selectMessageLoading,
} from "../../redux/selectors";

export const ChatbotDialogs = () => {
  const dispatch = useAppDispatch();
  const { selectedObject } = useStorageSelectors("ai_agents_telegram_bots");
  const chats = useChatsByRef(selectedObject?.value?.tg_bot_object?.ref);
  const [selectedValue, setSelectedValue] = useState<ChatObject | null>(null);
  const isMessageLoading = useAppSelector(selectMessageLoading);
  const messages = useAppSelector(selectChatMessages);
  const { t } = useTranslation();

  const bot_value = selectedObject?.value?.tg_bot_object as BotObject;

  const onSelectChat = (chat: ChatObject | null) => {
    setSelectedValue(chat);
  };

  const handleClick = (chatId: string) => {
    dispatch(
      getBotMessagesAction({
        ref: bot_value?.ref,
        chatId,
      }),
    );
  };

  const checkIsBlocked = useCallback(
    (id: string): boolean => {
      if (bot_value.black_list?.includes(id)) {
        return true;
      }
      return false;
    },
    [selectedValue, bot_value?.black_list, chats],
  );

  return (
    <div className={styles.container}>
      <AppUnderlinedTitle
        className={styles.title}
        leftContent={t("chatbot.dialogs_title")}
      />
      <DialogChatsSelection
        chats={chats}
        chat={selectedValue}
        onSelectChat={onSelectChat}
      />
      <ChatDatePicker bot={bot_value} />
      <ChatbotMessagesLayout
        chats={selectedValue === null ? chats : [selectedValue]}
        messages={messages}
        handleClick={handleClick}
        isChatBlocked={checkIsBlocked}
        isMessageLoading={isMessageLoading}
      />
    </div>
  );
};
